export default __webpack_public_path__ + "static/media/TJX_Logo.svg.908fc0fd.png";